import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { APP_TEXT_EN, APP_TEXT_ES, Language } from '../../../shared/constants/app.constants';
import { GlobalService } from '../../../shared/services/global.service';
import { SharedDataService } from 'src/app/shared/services/registration.service';
import { UtilService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-event-section',
  templateUrl: './event-section.component.html',
  styleUrls: ['./event-section.component.scss']
})

export class EventSectionComponent implements OnInit {

   @ViewChild('eventsContainer') scrolltarget!: ElementRef;
  public language : string = 'EN';
  public textConstants: any = this.language === 'EN' ? APP_TEXT_EN : APP_TEXT_ES;

  public title!: string ;
  public appointmentsAvailable: boolean = false;
  public ctaAppointmentText!: string;
  public ctaAppointmentButtonText!: string;

  public onDemandWebinar: boolean = false;
  public onDemandWebinarText!: string;
  public appointmentOnly: boolean = false;
  public appointmentOnlyText!: string;

  public events: any[] = [];
  public eventCount: number = 0;
  eventDates:{eventId:number, eventDate:string, eventData:any, titleVenue:string, isTitle:boolean}[]=[];
  langDictionary:any;
  contentList:string[] = [];
  isSectionVisible:boolean = true
  pagedata:any;

  constructor(private globalService: GlobalService, private sharedDataService: SharedDataService,
    private scrollService: UtilService) { }

    clearForNoEvents() {
      if (this.eventCount < 1){
        this.contentList = [];
        this.ctaAppointmentText = "";
        this.ctaAppointmentButtonText = "";
        this.appointmentOnlyText = "";
      }
    }
  ngOnInit(): void {
     this.scrollService.sectionVisibility$.subscribe( flag=> {
          this.isSectionVisible = flag;
        })

    this.langDictionary = this.globalService.Language;  
    this.globalService.jobInformation.subscribe((data) => {
      this.onDemandWebinarText = this.langDictionary.EVENTS.ON_DEMAND_WEBINAR_TEXT;
      this.appointmentOnlyText = this.langDictionary.EVENTS.APPOINTMENT_ONLY_TEXT;
      this.appointmentsAvailable = data?.jobInfo?.AppointmentsAvailable || false;
      this.ctaAppointmentText = (this.appointmentsAvailable)? data?.pageData?.sectionEvents?.ctaTextMakeAppointment || this.langDictionary.EVENTS.CTA_APPOINTMENT_TEXT:'';
      this.ctaAppointmentButtonText = (this.appointmentsAvailable)? data?.pageData?.sectionEvents?.ctaButtonMakeAppointment || this.langDictionary.EVENTS.CTA_APPOINTMENT_BUTTON_TEXT:'';
      this.eventCount = data.eventCount || 0;
      this.contentList = data?.pageData?.sectionEvents?.content || [];
      if (this.eventCount < 2) {
        this.title = data?.pageData?.sectionEvents?.title || this.langDictionary.EVENTS.TITLE_SINGLE;
        if (this.eventCount < 1) {
          this.title = this.langDictionary.EVENTS.CLOSED_TEXT;
        }
      }else{
        this.title = data?.pageData?.sectionEvents?.title || this.langDictionary.EVENTS.TITLE;
      }
      
      this.pagedata = data?.pageData
      this.events = data?.events || [];
      this.events = this.events.filter(event => event.EventId !== -1);
      this.events = this.events.map(event => {
        const [datePart, timePartRaw] = event.EventDateTime.split('T');
        let [hour, minute] = timePartRaw.split(':');
        let hourNum = parseInt(hour, 10);
        const ampm = hourNum >= 12 ? 'pm' : 'am';
        hourNum = hourNum % 12 || 12;
        const timePart = `${hourNum}:${minute} ${ampm}`;
        const dateObj = new Date(event.EventDateTime);
        const dayOfWeek = dateObj.toLocaleString('en-US', { weekday: 'short' });
        const dayOfWeekSpanish = dateObj.toLocaleString('es-ES', { weekday: 'short' });
        const monthAbbreviation = dateObj.toLocaleString('en-US', { month: 'short' });
        const monthAbbreviationSpanish = dateObj.toLocaleString('es-ES', { month: 'short' });
        const day = dateObj.getDate();
        const timeZone = event.TimeZone ? event.TimeZone.replace(/\s*\(.*?\)\s*/g, '').trim() : '';
        return {
          ...event,
          eventCount: this.events.length,
          date: datePart,
          time: timePart,
          dayOfWeek: dayOfWeek,
          dayOfWeekSpanish: dayOfWeekSpanish,
          monthAbbreviation: monthAbbreviation,
          monthAbbreviationSpanish: monthAbbreviationSpanish,
          day: day,
          timeZone: timeZone          
        };
      });
      data.pageData.sectionEvents.onDemandWebinar === "true" ? this.onDemandWebinar = true : this.onDemandWebinar = false;
      if (this.onDemandWebinar) {
        this.title = this.onDemandWebinarText;
      }
      data.pageData.sectionEvents.appointmentOnly === "true" ? this.appointmentOnly = true : this.appointmentOnly = false;
      if (this.appointmentOnly) {
        this.title = this.appointmentOnlyText;
      }

      this.globalService.eventCount = (this.events.length >= 0)? this.events.length : 0;
      if(this.globalService.eventCount == 1){
        this.sharedDataService.sendData(this.events[0]);
      }

      this.clearForNoEvents();
    });
    
    if(this.events?.length > 0){
      this.events.map(event =>{
         const dayOfWeek = (this.globalService.AppLanguage == Language.English)? event.dayOfWeek : event.dayOfWeekSpanish;
         const monthAbbreviation = (this.globalService.AppLanguage == Language.English)? event.monthAbbreviation : event.monthAbbreviationSpanish;
        const day = this.langDictionary.DAYS.find((m:any) => m.key === dayOfWeek.toUpperCase())?.value;
        const month = this.langDictionary.MONTHS.find((m:any) => m.key === monthAbbreviation.toUpperCase())?.value;
        const date = event.day;
        const time = event.time;
        const timezone = event.timeZone;
        const datesummary = `${day}, ${month} ${date} - ${time} ${timezone}`    

         const match = this.pagedata?.sectionEvents?.events
          ?.find((itm: any) => parseInt(event.EventId) === parseInt(itm.EventId));
        const titleOrVenue = match?.title || event.Name
        const IsTitle:boolean = (match?.title == null || match?.title == '' || match?.title == undefined)? false: true;
        this.eventDates.push({eventId: event.EventId, eventDate: datesummary, eventData: event, titleVenue : titleOrVenue, isTitle: IsTitle})
      })
      
      this.sharedDataService.eventDates(this.eventDates);
    }else{
      this.sharedDataService.eventDates(this.eventDates);
    }

    this.scrollService.scroll$.subscribe(targetId => {
      if (this.events?.length > 1) {
        this.scrollService.scrollTo(targetId, this.scrolltarget)
      }
    })  
 
  }
 

}
